class LicenseService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getLicense(data) {
    return this.apiService.get('/api/v1/license', data);
  }
}

export default LicenseService;